import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export interface ISetMetricsSuspendedStateParams extends IMultipleIdsParams {
    isSuspended: boolean;
}

export class SetMetricsSuspendedStateRequest extends Request<ISetMetricsSuspendedStateParams, IEmptyResult> {
  constructor(isSuspended: boolean, ids: string[]) {
    super('setMetricsSuspendedState', { isSuspended: isSuspended, ids: ids });
  }
}
